import { DataType } from "../../../enums/dataType";

class ResponseDto {

    public fieldId: string;

    public dataType: DataType;

    public isActionRequired: boolean;

    public appraiserFeedback: string;

    public feedbackComments: string;

    public nestedFieldId: string;

    public value: any = {};
}

export { ResponseDto };